const styles = {
  container: {
    fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    margin: 0,
    padding: 0,
    background: '#0A0A0F',
    color: '#E6E6F0',
    minHeight: '100vh',
  },
  header: {
    backgroundColor: '#12121A',
    color: '#D0D0FF',
    padding: '2.5rem 1rem',
    textAlign: 'center',
    boxShadow: '0 0 40px rgba(255, 255, 255, 0.05)',
  },
  main: {
    maxWidth: '960px',
    margin: '3rem auto',
    padding: '0 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
  },
  jobListing: {
    backgroundColor: '#14141E',
    boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
    padding: '2rem',
    borderRadius: '1rem',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    color: '#E0E0FF',
  },
  formContainer: {
    backgroundColor: '#14141E',
    padding: '2rem',
    borderRadius: '1rem',
    boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
  },
  label: {
    display: 'block',
    margin: '1rem 0 0.4rem 0',
    color: '#AAAAFF',
    fontWeight: 500,
    fontSize: '0.95rem',
  },
  input: {
    width: '100%',
    padding: '0.8rem 1rem',
    background: '#1E1E2A',
    color: '#F0F0FF',
    border: '1px solid #444',
    borderRadius: '0.6rem',
    fontSize: '1rem',
    outline: 'none',
  },
  textarea: {
    width: '100%',
    padding: '0.8rem 1rem',
    background: '#1E1E2A',
    color: '#F0F0FF',
    border: '1px solid #444',
    borderRadius: '0.6rem',
    fontSize: '1rem',
    resize: 'vertical',
    minHeight: '120px',
    outline: 'none',
  },
  button: {
    marginTop: '1.5rem',
    padding: '0.9rem 2rem',
    backgroundColor: '#4F46E5',
    border: 'none',
    borderRadius: '0.75rem',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.3s ease, transform 0.2s ease',
  },
  buttonHover: {
    backgroundColor: '#6D6BFF',
    transform: 'scale(1.03)',
  },
  thankYouMessage: {
    padding: '1.5rem',
    marginTop: '2rem',
    backgroundColor: '#1B2A1B',
    color: '#A6FFAA',
    borderRadius: '1rem',
    fontStyle: 'italic',
    textAlign: 'center',
    boxShadow: '0 0 12px rgba(0, 255, 150, 0.1)',
  },
};

export default styles;
